import React, { useEffect, useRef, useState } from "react";
import { Checkbox, Form, Input, InputNumber, Modal, Select, Spin } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import { save } from "../../../../features/save/saveSlice";
import {
  fetchFiscPeriod, 
  fetchLeaveTypeAnl, 
} from "../../../../features/dropdown/dropdownSlice";
import { fetchPersonnelFolders } from "../../../../features/folder/folderSlice";

const { TextArea } = Input;

const AddLeaveScheduleModal = ({
  open,
  handleCancel,
  handleFetchData,
  prodd,
}) => {
  const [form] = Form.useForm();
  const formRef = useRef(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { leaveType,fiscalP, leaveTypeAnl, loading } = useSelector(
    (state) => state.dropdown
  );

  const { personnelFolders } = useSelector((state) => state.folder);

  const { saving } = useSelector((state) => state.save);

  const [formData, setFormData] = useState(prodd);

  const onChangeOther = (value, fieldName) => {
    setFormData((prev) => ({
      ...prev,
      [fieldName]: value,
    }));
  };

  async function handleSelectChange(value, formName) {
    await setFormData((prevData) => ({
      ...prevData,
      [formName]: value,
    }));
  }

  const onFinish = async (data) => {
    if (!formData?.ppId) {
      toast.error("Please select staff");
      return;
    }
    if (!formData?.fpPyear) {
      toast.error("Please select leave year");
      return;
    }
    if (!formData?.ltId) {
      toast.error("Please select leave type");
      return;
    }

    const res = await dispatch(
      save({
        lsId:prodd?.lsId ? prodd?.lsId  : null,
        ppId: formData?.ppId,
        fpPyear: formData?.fpPyear,
        ltId: formData?.ltId,
        lsBalbf: formData?.lsBalbf,
        lsForfeited: formData?.lsForfeited,
        lsEntitlement: formData?.lsEntitlement,
        lsTaken: formData?.lsTaken,
        lsBaltotal: formData?.lsBaltotal,
        plannedLeaveMonth:formData?.plannedLeaveMonth,

        url: "hr/saveLeaveSchedule.action",
      })
    );
    if (res?.payload?.success) {
      await toast.success(res?.payload?.messages?.message);
      await handleFetchData();
      await setFormData({});
      await handleCancel();
      await form.resetFields();
    } else {
      toast.error(res?.payload?.messages?.message);
    }
  };

  async function fetchLeaveTypeAnlData(page, size) {
    dispatch(fetchLeaveTypeAnl());
  }
  async function fetchPersonnelData(page, size) {
    dispatch(fetchPersonnelFolders());
  }
  async function fetchFiscPeriodData(page, size) {
    dispatch(fetchFiscPeriod());
  }

  useEffect(() => {
    setFormData(prodd);
  }, [prodd]);

  return (
    <>
      <Modal
        className="modal-btn mod-height mod-footer"
        title={
          prodd
            ? `Edit leave schedule ${prodd?.ltLvtypename}`
            : "Add leave schedule details"
        }
        open={open}
        onOk={onFinish}
        onCancel={handleCancel}
        width={850}
      >
        <Form
          layout="vertical"
          ref={formRef}
          name="control-ref"
          onFinish={onFinish}
          className=" "
          style={{
            maxWidth: "100%",
          }}
          form={form}
        >
          <div className="grid grid-cols-2 gap-x-5">
          <Form.Item
            className=""
            label={<span>Staff</span>}
            rules={[
              {
                required: true,
                message: "Please select staff",
              },
            ]}
          >
            <Select
              name="ppId"
              className=""
              allowClear
              style={{
                width: "100%",
              }}
              options={
                personnelFolders?.length > 0 &&
                personnelFolders?.map((item) => ({
                  value: item?.ppId,
                  label: item?.ppPfno + " - " + item?.ppFullname,
                }))
              }
              onChange={(value) => {
                handleSelectChange(value, "ppId");
              }}
              value={formData?.ppId}
              showSearch
              optionFilterProp="children"
              filterOption={(input, option) =>
                (option?.label?.toLocaleLowerCase() ?? "").includes(
                  input?.toLocaleLowerCase()
                )
              }
              onDropdownVisibleChange={() => {
                fetchPersonnelData();
              }}
              dropdownRender={(menu) => (
                <>
                  {loading && (
                    <div
                      style={{
                        padding: "8px",
                        textAlign: "center",
                      }}
                    >
                      <Spin className="sms-spin" />
                    </div>
                  )}
                  {menu}
                </>
              )}
            />
          </Form.Item>

          <Form.Item
            className=""
            label={<span>Leave Year</span>}
            rules={[
              {
                required: true,
                message: "Please select Leave Year",
              },
            ]}
          >
            <Select
              name="fpPyear"
              className=""
              allowClear
              style={{
                width: "100%",
              }}
              options={
                fiscalP?.length > 0 &&
                fiscalP?.map((item) => ({
                  value: item?.fpPyear,
                  label: item?.fpPyear,
                }))
              }
              onChange={(value) => {
                handleSelectChange(value, "fpPyear");
              }}
              value={formData?.fpPyear}
              showSearch
              optionFilterProp="children"
              filterOption={(input, option) =>
                (option?.label?.toLocaleLowerCase() ?? "").includes(
                  input?.toLocaleLowerCase()
                )
              }
              onDropdownVisibleChange={() => {
                fetchFiscPeriodData();
              }}
              dropdownRender={(menu) => (
                <>
                  {loading && (
                    <div
                      style={{
                        padding: "8px",
                        textAlign: "center",
                      }}
                    >
                      <Spin className="sms-spin" />
                    </div>
                  )}
                  {menu}
                </>
              )}
            />
          </Form.Item>

          <Form.Item
            className=""
            label={<span>Leave Type</span>}
            rules={[
              {
                required: true,
                message: "Please select Leave Type",
              },
            ]}
          >
            <Select
              name="ltLvtype"
              className=""
              allowClear
              style={{
                width: "100%",
              }}
              options={
                leaveTypeAnl?.length > 0 &&
                leaveTypeAnl?.map((item) => ({
                  value: item?.ltId,
                  label: item?.ltLvtypename,
                }))
              }
              onChange={(value) => {
                handleSelectChange(value, "ltId");
              }}
              value={formData?.ltId}
              showSearch
              optionFilterProp="children"
              filterOption={(input, option) =>
                (option?.label?.toLocaleLowerCase() ?? "").includes(
                  input?.toLocaleLowerCase()
                )
              }
              onDropdownVisibleChange={() => {
                fetchLeaveTypeAnlData();
              }}
              dropdownRender={(menu) => (
                <>
                  {loading && (
                    <div
                      style={{
                        padding: "8px",
                        textAlign: "center",
                      }}
                    >
                      <Spin className="sms-spin" />
                    </div>
                  )}
                  {menu}
                </>
              )}
            />
          </Form.Item>

          <Form.Item
            label="Balance BF"
            rules={[
              {
                required: true,
                message: "Enter balance BF",
              },
            ]}
          >
            <InputNumber
              name="lsBalbf"
              value={formData?.lsBalbf}
              min={0}
              formatter={(value) =>
                `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
              }
              parser={(value) => value?.replace(/\$\s?|(,*)/g, "")}
              onChange={(value) => onChangeOther(value, "lsBalbf")}
              className="input flex"
            />
          </Form.Item>

          <Form.Item
            label="Forfeited"
            rules={[
              {
                required: true,
                message: "Enter Forfeited",
              },
            ]}
          >
            <InputNumber
              name="lsForfeited"
              value={formData?.lsForfeited}
              min={0}
              formatter={(value) =>
                `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
              }
              parser={(value) => value?.replace(/\$\s?|(,*)/g, "")}
              onChange={(value) => onChangeOther(value, "lsForfeited")}
              className="input flex"
            />
          </Form.Item>

          <Form.Item
            label="Entitlement"
            rules={[
              {
                required: true,
                message: "Enter Entitlement",
              },
            ]}
          >
            <InputNumber
              name="lsEntitlement"
              value={formData?.lsEntitlement}
              min={0}
              formatter={(value) =>
                `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
              }
              parser={(value) => value?.replace(/\$\s?|(,*)/g, "")}
              onChange={(value) => onChangeOther(value, "lsEntitlement")}
              className="input flex"
            />
          </Form.Item>

          <Form.Item
            label="Days Taken"
            rules={[
              {
                required: true,
                message: "Enter Days Taken",
              },
            ]}
          >
            <InputNumber
              name="lsTaken"
              value={formData?.lsTaken}
              min={0}
              formatter={(value) =>
                `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
              }
              parser={(value) => value?.replace(/\$\s?|(,*)/g, "")}
              onChange={(value) => onChangeOther(value, "lsTaken")}
              className="input flex"
            />
          </Form.Item>

          <Form.Item
            label="Total Balance"
            rules={[
              {
                required: true,
                message: "Enter Total Balance",
              },
            ]}
          >
            <InputNumber
              name="lsBaltotal"
              value={formData?.lsBaltotal}
              min={0}
              formatter={(value) =>
                `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
              }
              parser={(value) => value?.replace(/\$\s?|(,*)/g, "")}
              onChange={(value) => onChangeOther(value, "lsBaltotal")}
              className="input flex"
            />
          </Form.Item>

          <Form.Item
            label="Planned Leave Month"
            extra={"You should enter a number 1-12"}
            rules={[
              {
                required: true,
                message: "Enter planned leave month",
              },
            ]}
          >
            <InputNumber
              name="plannedLeaveMonth"
              value={formData?.plannedLeaveMonth}
              min={1}
              max={12}
              formatter={(value) =>
                `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
              }
              parser={(value) => value?.replace(/\$\s?|(,*)/g, "")}
              onChange={(value) => onChangeOther(value, "plannedLeaveMonth")}
              className="input flex"
            />
          </Form.Item>
          </div>

          <div className="flex lg:flex-row flex-col justify-between mt-[56px] mb-[48px]">
            <div className="justify-start"></div>
            <div className="justify-end flex items-center gap-x-2">
              <div className="w-[200px]">
                <button
                  key="back"
                  type="button"
                  onClick={handleCancel}
                  className="cstm-btn !bg-white !text-lightBlack !border !border-lightBlack"
                >
                  Cancel
                </button>
              </div>

              <div className="w-[200px]">
                <button
                  key="submit"
                  type="submit"
                  className="cstm-btn"
                  disabled={saving}
                >
                  {saving ? <Spin /> : "Create"}
                </button>
              </div>
            </div>
          </div>
        </Form>
      </Modal>
    </>
  );
};
export default AddLeaveScheduleModal;
